export enum EntryKind {
	'InternalNote' = 'InternalNote',
	'PatientHistory' = 'PatientHistory',
	'Treatment' = 'Treatment',
	'Diagnosis' = 'Diagnosis',
	'Medicine' = 'Medicine',
	'MedicineStop' = 'MedicineStop',
	'Documents' = 'Documents',
	'Pictures' = 'Pictures',
	'Anamnesis' = 'Anamnesis'
}
